import React, {ComponentClass} from 'react';
import {OfflineIcon} from 'components';
import {Offline as Offline_} from 'react-detect-offline';
import {useTranslation} from 'react-i18next';

export const Offline: ComponentClass = Offline_;

const OfflineNotification: React.FC<{}> = () => {
  const {t} = useTranslation();
  return (
    <div>
      <Offline>
        <div className="fixed inset-x-0 top-0 z-40 flex justify-items-center justify-center items-end justify-end p-3 pointer-events-none block">
          <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto transform ease-out duration-1000 transition opacity-100">
            <div className="rounded-lg shadow-xs overflow-hidden">
              <div className="p-3">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <OfflineIcon
                      width={30}
                      height={30}
                      strokeColor="text-yellow-200"
                      strokeWidth={15}
                    />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-1">
                    <p className="text-sm leading-5 font-medium text-gray-900">
                      {t('youAreOffline')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Offline>
    </div>
  );
};

export default OfflineNotification;
